export default __webpack_public_path__ + "static/media/redFull.09beb537.svg";